export const DASHBOARD_FILTER_DETAILS_REQUEST = 'DASHBOARD_FILTER_DETAILS_REQUEST';
export const DASHBOARD_FILTER_DETAILS_SUCCESS = 'DASHBOARD_FILTER_DETAILS_SUCCESS';
export const DASHBOARD_FILTER_DETAILS_ERROR = 'DASHBOARD_FILTER_DETAILS_ERROR';

export const SET_SCENARIO_GROUP_AND_BENCH_NAME_REQUEST = 'SET_SCENARIO_GROUP_AND_BENCH_NAME_REQUEST'
export const SET_TAG_NAME_ARRANGE_SCENARIO_GROUP_IDS = 'SET_TAG_NAME_ARRANGE_SCENARIO_GROUP_IDS';
export const SET_SCENARIO_GROUP_AND_BENCH_NAME_ERROR = 'SET_SCENARIO_GROUP_AND_BENCH_NAME_ERROR'
export const SET_SCENARIO_GROUP_ID_ARRANGE_BENCH_NAMES = 'SET_SCENARIO_GROUP_ID_ARRANGE_BENCH_NAMES';
export const SET_SCENARIO_GROUP_NAME_WITH_ID_ARRANGE_BENCH_NAMES = 'SET_SCENARIO_GROUP_NAME_WITH_ID_ARRANGE_BENCH_NAMES';
export const SET_SCENARIO_GROUP_NAME_ARRANGE_BENCH_NAMES = 'SET_SCENARIO_GROUP_NAME_ARRANGE_BENCH_NAMES';
export const SET_BENCH_NAME_ARRANGE_RUN_IDS = 'SET_BENCH_NAME_ARRANGE_RUN_IDS';
export const SET_RUN_ID_ARRANGE_SCENARIO_UUIDS_REQUEST = 'SET_RUN_ID_ARRANGE_SCENARIO_UUIDS_REQUEST'
export const SET_RUN_ID_ARRANGE_SCENARIO_UUIDS = 'SET_RUN_ID_ARRANGE_SCENARIO_UUIDS';
export const SET_RUN_ID_ARRANGE_SCENARIO_UUIDS_ERROR = 'SET_RUN_ID_ARRANGE_SCENARIO_UUIDS_ERROR';
export const SET_SCENARIO_UUID_AND_DESCRIPTION = 'SET_SCENARIO_UUID_AND_DESCRIPTION';
export const SET_FORM_FILTER_DATA_RESET = 'SET_FORM_FILTER_DATA_RESET';
